import Config from "./config.js"
import JSEncrypt from "jsencrypt"
import axios from "axios"
import { getToken } from "./auth"

axios.defaults.baseURL = Config.baseUrl
axios.defaults.headers = {
    "X-Requested-With": "XMLHttpRequest",
    "content-type": "application/json"
}
axios.defaults.responseType = "json"
axios.defaults.timeout = 60 * 1000
// axios.defaults.withCredentials = true
// axios.defaults.timeout = 100;// 測試請求超時代碼，勿刪

/**
 * http單個請求
 * @param {object} params 請求參數
 * @param {integer} successCode 接口正常返回結果標識
 *
 * @returns Promise
 */
export default function request(params, successCode = 0, method = "POST") {
    const url = params.url // 請求路徑
    const data = {
        app_type: "pc",
        app_type_name: "電腦端"
    }

    const token = getToken()
    if (token) data.token = token

    // 參數
    if (params.data != undefined) Object.assign(data, params.data)

    // 請求參數加密
    if (parseInt(Config.apiSecurity)) {
        let jsencrypt = new JSEncrypt()
        jsencrypt.setPublicKey(Config.publicKey)
        let encrypt = encodeURIComponent(jsencrypt.encrypt(JSON.stringify(params.data)))
        data = {
            encrypt
        }
    }

    //異步
    return axios({ url: url, method: method, data })
        .then(res => {
            const { code } = res.data || {}
            if (code == successCode) return res.data
            else return Promise.reject(res.data)
        })
        .catch(error => {
            const { data } = error
            if (data === "AuthError") {
                vue.$store.dispatch("member/remove_token")
                if (params.forceLogin) {
                    vue.$router.push(`/login?redirect=${encodeURIComponent(vue.$router.history.current.fullPath)}`)
                }
            }

            return Promise.reject(error)
        })
}

/**
 * 並發請求
 * @param {array} params 並發請求參數數組，傳入數組中對象的順序要匹配 data 中 url
 * @var 該方法為並發請求，數據會在全部請求完之後才返回
 * 該方法不建議使用。
 */
export function conRequest(params) {
    if (Object.prototype.toString.call(params) != "[object Array]") {
        return Promise.reject({ code: -1, msg: "參數必須為數組" })
    }

    //同步並發
    var quest = []
    for (var i = 0; i < url.length; i++) {
        quest.push(
            axios({
                url: params[i].url,
                method: method,
                params: params[i].data
            })
        )
    }

    axios
        .all(quest)
        .then(
            axios.spread(() => {
                // 請求全部完成後執行
                var res = []
                for (let i = 0; i < arguments.length; i++) {
                    res.push(arguments[i].data)
                }

                return res
            })
        )
        .catch(error => {
            // '請求超時，請檢查網絡'
            vue.$message({
                message: error,
                type: "warning"
            })

            return Promise.reject(error)
        })
}
